import { IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { OccupyFreeSpace } from "../../primitives/ActionRow";
import { PseudoLink } from "../../primitives/Common.styles";
import { Form } from "../../primitives/Forms";
import { LoadingIndicator } from "../../primitives/LoadingIndicator";
import { SearchField } from "../../primitives/SearchField";
import { TableForFields } from "../../schemed";
import { EmailItem } from "../types";
import { useEmails } from "../useEmails";
import { Popup } from "./Popup";
import { getDefaultTemplateContent } from "../../Notifications/NotificationTemplateEditor";

const entryEmail = (): EmailItem => ({
    description: "",
    title: "",
    active: true,
    code: "",
    body: "",
    autowrap_html_body: true,
    is_powertemplate_content: true,
    body_template: getDefaultTemplateContent(window.location.href),
    subject: ""
});

const noSelect = { email: null, isNew: false };

export const EmailsPage = ({apiPrefix = '/email'}: {apiPrefix?: string}) => {
    const emailsApi = useEmails(apiPrefix);
    const { schema, loading, emails } = emailsApi;

    const [codeFromUrl, setCodeFromUrl] = useState<string>("");
    const [selected, setSelected] = useState<{ email: (EmailItem | null), isNew: boolean }>(noSelect);

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      setCodeFromUrl(params.get("code") || "");
    }, []);
    
    useEffect(() => {
      if(codeFromUrl && emailsApi.emails.length) {
        const byCode = emailsApi.emails.find(e => e.code === codeFromUrl);
        if(byCode) {
          setSelected({ email: byCode, isNew: false });
          setCodeFromUrl("");
        }
      }
    }, [codeFromUrl, emailsApi.emails]);


    return <Form
            headerItems={<>
                <IconButton color='primary' onClick={() => setSelected({ email: entryEmail(), isNew: true })}>
                    <Add />
                </IconButton>
                {loading && <LoadingIndicator />}
                <OccupyFreeSpace />
                <SearchField
                    filter={emailsApi.filter.filter}
                    setFilter={emailsApi.filter.setFilter}
                    doSearch={() => {}}
                    noButton
                    autoFocus
                    />
            </>}
            >

        <TableForFields
            sorting={emailsApi.sorting}
            fields={[
                ["code"],
                ["title"],
                ["description"],
                ["active", {width: 100}],
            ]}
            schema={schema}
            data={emails}
            fieldElement={(field) => 
                field === "code"? 
                    ((row: EmailItem) => <PseudoLink onClick={() => setSelected({ email: row, isNew: false })}>{row.code}</PseudoLink> )
                    :
                     null
            }
        />

        {selected.email && 
            <Popup 
                data={{
                    isNew: selected.isNew,
                    email: selected.email,
                    ...emailsApi,
                    onClose: () => setSelected(noSelect),
                    onChange: (row: EmailItem) => setSelected({ email: row, isNew: selected.isNew }),
                }} 
            />}

    </Form>
}